import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { DataRoomShareableLink } from 'models/ShareableLink';
import { Button, Loader } from 'ncoded-component-library';
import ResolvePagination from 'components/ResolvePagination';
import { useTranslation } from 'react-i18next';
import ShareableLinksMobileItem from './components/ShareableLinksMobileItem';
import CreateShareableLinkContext from 'router/subrouters/DataRoom/providers/CreateShareableLink/CreateShareableLink.context';

import './ShareableLinksMobile.styles.scss';

type ShareableLinksMobileProps = {
  className?: string;
  isLoading: boolean;
  totalPages: number;
  shareableLinks: DataRoomShareableLink[];
  showVisits?: boolean;
  updateShareableLink: (link: DataRoomShareableLink) => void;
  onRowClick: (link: DataRoomShareableLink) => void;
};

const ShareableLinksMobile: React.FC<ShareableLinksMobileProps> = (props) => {
  const {
    className,
    isLoading,
    totalPages,
    shareableLinks,
    showVisits = false,
    updateShareableLink,
    onRowClick,
  } = props;

  const { openCreateShareableLink } = useContext(CreateShareableLinkContext);

  const loading = useMemo(
    () => isLoading && !shareableLinks?.length,
    [isLoading, shareableLinks?.length],
  );

  const classes = classNames('shareable-links-mobile', { loading }, className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      {loading && <Loader />}

      <Button variant="outline" onClick={() => openCreateShareableLink()}>
        {t('createSecureLink')}
      </Button>

      <div className="white-panel">
        {shareableLinks.map((link) => (
          <ShareableLinksMobileItem
            key={link?._id}
            link={link}
            showVisits={showVisits}
            updateShareableLink={updateShareableLink}
            onRowClick={onRowClick}
          />
        ))}
      </div>

      <ResolvePagination totalPages={totalPages} />
    </div>
  );
};

export default ShareableLinksMobile;
